import React from 'react';
import DialogTitle from '../../DialogTitle';
import FileDropBox from '../../../ui/FileDropBox/FileDropBox';
import { useFormContext, Controller } from 'react-hook-form';
import z from 'zod';
import { newProductSchema } from '../../../../schemas/newProductSchema';
import { IonicButton } from 'ionic-ui';

export default function StepTwo({ onNext }: { onNext: () => void }) {
  const { control } = useFormContext<z.infer<typeof newProductSchema>>();

  return (
    <div className="sm:w-[55vw] max-xlg:w-[660px] dialog-content space-y-4">
      <DialogTitle>Upload Product images</DialogTitle>
      <label>Upload 3-4 images, 750px by 750px, 500kb each </label>
      {/* PRODUCT IMAGES */}
      <Controller
        name="product_images"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <FileDropBox
              {...field}
              acceptedTypes={{
                'image/jpeg': ['.jpg', '.jpeg'],
                'image/png': ['.png'],
                'image/svg+xml': ['.svg'],
              }}
              allowCropping
              cropperAspectRatio={1 / 1}
              warning="Your Hero Image should come first"
              maxFiles={4}
              errorMessage={fieldState.error?.message}
            />
            <div className="grid grid-cols-2 w-full sm:grid-cols-3 [direction:rtl]">
              <IonicButton disabled={fieldState.invalid} onClick={onNext}>
                next
              </IonicButton>
            </div>
          </>
        )}
      />
    </div>
  );
}
